import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: "website" | "article";
  article?: {
    publishedTime?: string;
    modifiedTime?: string;
    author?: string;
    section?: string;
    tags?: string[];
  };
}

const SEO = ({
  title = "SKECHA - Turn Your Photos into Beautiful Coloring Pages",
  description = "Transform your family photos into personalized coloring pages with AI. Create magical coloring book pages from photos in seconds. Perfect for kids, families, and creative fun.",
  keywords = "coloring pages, photo to coloring page, AI coloring book, personalized coloring pages, children activities, family fun, photo transformation, custom coloring sheets, kids creativity",
  image = "https://storage.googleapis.com/gpt-engineer-file-uploads/6p69kMobG9NsN7tRHqr9ZhecKXw2/social-images/social-1758079385291-Screenshot 2025-09-17 132256.png",
  url = "https://skecha.com",
  type = "website",
  article,
}: SEOProps) => {
  const siteTitle = title.includes("SKECHA") ? title : `${title} | SKECHA`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{siteTitle}</title>
      <meta name="title" content={siteTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Cuboid Ventures" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="SKECHA" />
      <meta property="og:locale" content="en_US" />

      {/* Article specific tags */}
      {article && type === "article" && (
        <>
          {article.publishedTime && (
            <meta property="article:published_time" content={article.publishedTime} />
          )}
          {article.modifiedTime && (
            <meta property="article:modified_time" content={article.modifiedTime} />
          )}
          {article.author && <meta property="article:author" content={article.author} />}
          {article.section && <meta property="article:section" content={article.section} />}
          {article.tags?.map((tag) => (
            <meta key={tag} property="article:tag" content={tag} />
          ))}
        </>
      )}

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={siteTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      <meta name="twitter:site" content="@lovable_dev" />

      {/* Additional SEO tags */}
      <meta name="theme-color" content="#8B5CF6" />
      <meta name="apple-mobile-web-app-capable" content="yes" />
      <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />
      <meta name="apple-mobile-web-app-title" content="SKECHA" />
      <meta name="application-name" content="SKECHA" />
      <meta name="msapplication-TileColor" content="#8B5CF6" />
      <meta name="format-detection" content="telephone=no" />
    </Helmet>
  );
};

export default SEO;
